// extracted by mini-css-extract-plugin
export default {"input":"CandidateDashboardChangePassword_input__d2H3T"};